<template>
  <Modal
    :show="show"
    @close="close"
    class="modal-image"
  >
    <template slot="modal-title">
      <div class="modal-title">
        Görsel Seçimi
      </div>
    </template>
    <template slot="modal-body">
      <div class="content">
        <ul class="options">
          <li @click="onSelect('fromGallery')">
            <label>
              <img :src="`${$root.cdnUrl}assets/icon-picture.svg`">
              Telefon Galerisinden Görsel Yükle
              <input
                class="fileInput"
                type="file"
                ref="fileInput"
                accept="image/png,image/jpg,image/jpeg"
                @change="onChangeImages"
              >
            </label>
          </li>
          <li
            @click="onSelect('fromCamera')"
            class="{ disabled }"
          >
            <label>
              <img :src="`${$root.cdnUrl}assets/icon-camera.svg`">
              Fotoğraf Çekerek Yükle
              <input
                class="fileInput"
                type="file"
                ref="fileCamera"
                accept="capture=camera"
                @change="onChangeImages"
              >
            </label>
          </li>
          <li
            @click="onSelect('fromMediaCenter')"
            class="trendyol"
          >
            <label>
              <img :src="`${$root.cdnUrl}assets/icon-add-circle.svg`">
              Trendyol Görsel Galerisinden Yükle
            </label>
          </li>
        </ul>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import messageHandler from '@/utils/message';
const maxAllowedSize = 10 * 1024 * 1024;
export default {
  name: 'ModalImage',
  components: { Modal },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onSelect (option) {
      if (option === 'fromMediaCenter') {
        this.$emit('onMediaCenter');
        this.close();
      }
    },
    close () {
      this.$emit('close');
    },
    onChangeImages (e) {
      let sizeCheck = false;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        files.forEach(file => {
          if (file.size > maxAllowedSize) {
            sizeCheck = true;
          }
        });

        if (sizeCheck) {
          messageHandler.warning('Maksimum yükleyeceğiniz dosya boyutu 10MB olmalıdır.');
        } else {
          const images = [...files].map(im => {
            im.isFile = true;
            im.url = URL.createObjectURL(im);
            return im;
          });
          this.$emit('onSelect', images);
          this.close();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .modal-image {
    .content {
      margin: 0 -20px;
      .options {
        border-top: 1px solid #DEE0EB;
        list-style: none;
        margin: 0;
        padding: 0;
        overflow: auto;
        max-height: 200px;
        li {
          position: relative;
          border-bottom: 1px solid #DEE0EB;
          &.trendyol {
            color: #fff;
            background-color: rgb(242, 122, 26);
            border-bottom: 1px solid rgb(242, 122, 26);
          }
          label {
            display: block;
            padding: 15px;
            padding-right: 35px;
            position: relative;
            img {
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);
            }
          }
        }
      }
      .fileInput {
        position: absolute;
        z-index: -99999;
        display: none;
      }
    }

    ::v-deep .modal {
      @media screen and (max-height: 550px) {
        top: initial;
        bottom: 0;
        .modal-body {
          margin: 0 -20px;
          min-height: 1px;
          .content {
            margin: 0;
            .options {
              max-height: 200px;
            }
          }
        }
      }
    }
  }
</style>
